import React from "react";

export default class SlideDown extends React.Component {
  componentDidMount() {
    $(this.el).slideDown();
  }

  render() {
    return (
      <div ref={(el) => this.el = el} style={{ display: 'none' }}>
        {this.props.children}
      </div>
    );
  }
}
